interface Chapter {
  number: number;
  title: string;
  updatedAt: string;
}

interface RelatedItem {
  id: string;
  title: string;
  author: string;
  imageUrl: string;
}

interface ManhuaDetail {
  id: string;
  title: string;
  author: string;
  genre: string;
  status: string;
  rating: string;
  views: string;
  favorites: string;
  description: string;
  coverImageUrl: string;
  tags: string[];
  totalChapters: number;
  chapters: Chapter[];
  relatedManhua: RelatedItem[];
}

const genChapters = (total: number, seed: string): Chapter[] => {
  const titles: Record<string, string[]> = {
    sword: ['剑道巅峰', '最后一战（下）', '最后一战（上）', '破而后立', '绝境', '天罚降临', '剑意圆满', '顿悟', '九死一生', '秘境深处', '上古遗迹', '风云际会', '第三百话纪念', '各方云动', '暗流涌动', '盟主之争', '武林大会', '抵达帝都', '路遇故人', '启程'],
    level: ['最终觉醒', '暗影君主', '兽潮来袭', 'S级地下城', '猎人之夜', '重生之谜', '系统升级', '新技能解锁', '世界树之巅', '巨龙讨伐', '公会之战', '排名飙升', '隐藏任务', '同伴集结', '黑暗降临', '反击号角', '试炼之门', '危机四伏', '初次狩猎', '觉醒之日'],
    goddess: ['毕业典礼', '化妆大赛', '真心告白', '误会解除', '迎新晚会', '情敌出现', '修学旅行', '第一次约会', '闺蜜危机', '暑假打工', '校园祭典', '图书馆邂逅', '转学生的秘密', '改变的开始', '素颜初现', '化妆的力量', '新的学期', '暗恋心事', '自卑与勇气', '命运相遇'],
    reader: ['终章序幕', '最后的场景', '世界之敌', '魔王降临', '全知之力', '回归条件', '记忆碎片', '隐藏剧情', '第十二个回归者', '大崩坏', '背叛者现身', '地下避难所', '怪物浪潮', '生存之战', '能力觉醒', '首尔站', '第一次回归', '血色流星', '末日预告', '平凡日常'],
    prince: ['世子归来', '王座之争', '真相大白', '密室逃脱', '血书之谜', '深夜密会', '朝堂风云', '暗杀未遂', '世子殿下的秘密', '宫墙之外'],
    villainess: ['复仇计划', '皇帝陛下的婚约', '重返宴会', '前世记忆', '致命邂逅', '皇后的阴谋', '花园密谈', '初次登场', '觉醒之日', '死亡与重生'],
    count: ['毕业试炼', '剑术对决', '家族秘密', '学院祭', '第一次任务', '剑术课风波', '图书馆奇遇', '转生者觉醒', '伯爵家的清晨', '废物的新生'],
    aesthetics: ['反派宣言', '王都舞会', '童年往事', '初见公爵', '命运之线', '玫瑰园的邂逅', '皇宫邀约', '家族复兴', '穿越之夜', '美学初现'],
    hunter: ['龙巢决战', 'SSS级觉醒', '深渊之门', '最强猎人', '讨伐任务', '公会选拔', '暗影来袭', '排名晋级', '猎人之夜', '觉醒测试'],
    survival: ['最终防线', '疫苗真相', '尸潮来袭', '避难所沦陷', '变异的开始', '同伴失踪', '城市废墟', '末世第一天', '灾难预警', '日常的最后'],
    dragon: ['龙王震怒', '身世之谜', '边境之战', '公主的逃亡', '龙宫密宝', '战场邂逅', '被诅咒的血脉', '来自龙宫的婚约', '将军府危机', '命运之始'],
    prison: ['自由之门', '真相浮现', '塔中密道', '王的真面目', '逃亡计划', '狱中盟友', '公主的反击', '囚笼岁月', '大婚之日', '被囚禁的少女'],
    star: ['归途', '希望坐标', '舰队遭遇战', '虫洞危机', '星际通讯', '星球探索', '失联信号', '未知星球', '紧急迫降', '启程之日'],
    destiny: ['天命所归', '神谕降临', '命运之战', '神殿遗迹', '月下契约', '神秘旅人', '守护者觉醒', '预言应验', '灵力测试', '平凡少女'],
    boss: ['完美婚礼', '商场危机', '情敌归来', '求婚大作战', '家庭阻力', '浪漫旅行', '初次见家长', '办公室暧昧', '天台相遇', '入职第一天'],
    ghost: ['永夜降临', '校园怪谈', '诅咒之源', '第七个房间', '深夜铃声', '废弃教室', '社团活动', '不存在的同学', '转学第一天', '深夜怪谈'],
  };

  const key = seed;
  const list = titles[key] || titles.sword;
  const chapters: Chapter[] = [];
  for (let i = 0; i < Math.min(total, list.length); i++) {
    const date = new Date('2026-07-03');
    date.setDate(date.getDate() - i * 2);
    chapters.push({
      number: total - i,
      title: list[i],
      updatedAt: date.toISOString().split('T')[0],
    });
  }
  return chapters;
};

export const manhuaDetailMap: Record<string, ManhuaDetail> = {
  '1': {
    id: '1',
    title: '剑尊归来',
    author: '李贤宇',
    genre: '武侠 / 重生 / 动作',
    status: '连载中',
    rating: '9.8',
    views: '2,156万',
    favorites: '89万',
    description: '一代剑尊李玄天在渡劫飞升之际遭人暗算，肉身陨灭，却意外重生于百年之后的一个落魄世家少年身上。重活一世，他携前世记忆与绝世剑法强势归来。昔日仇敌尚在人世，这一世，他定要让所有人付出代价！江湖风云再起，剑尊之名必将再次响彻九州大地！',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20detailed%20cover%20art%2C%20ancient%20martial%20arts%20master%20holding%20legendary%20sword%2C%20dramatic%20epic%20pose%2C%20golden%20divine%20light%20from%20above%2C%20traditional%20Asian%20temple%20background%2C%20premium%20webtoon%20cover%20quality%2C%20rich%20warm%20colors&width=600&height=800&seq=manhua-cover-01&orientation=portrait',
    tags: ['重生', '武侠', '复仇', '热血', '爽文', '剑道'],
    totalChapters: 312,
    chapters: genChapters(312, 'sword'),
    relatedManhua: [
      { id: '2', title: '我独自升级', author: '崔秀敏', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20fantasy%20warrior%2C%20shadow%20army%2C%20intense%20gaze%2C%20purple%20and%20black%20tones%2C%20related%20webtoon%20cover&width=400&height=533&seq=rel-m01-02&orientation=portrait' },
      { id: '4', title: '全知读者视角', author: '崔元英', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20reader%20character%2C%20cosmic%20background%2C%20blue%20and%20gold%20tones%2C%20related%20webtoon%20cover&width=400&height=533&seq=rel-m01-04&orientation=portrait' },
      { id: '9', title: 'SSS级猎人', author: '郑宇硕', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20powerful%20hunter%20action%20pose%2C%20dungeon%20background%2C%20orange%20and%20dark%20tones%2C%20related%20webtoon%20cover&width=400&height=533&seq=rel-m01-09&orientation=portrait' },
      { id: '7', title: '成为伯爵家的废物', author: '赵云熙', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20young%20nobleman%20in%20academy%2C%20fantasy%20castle%2C%20golden%20warm%20tones%2C%20related%20webtoon%20cover&width=400&height=533&seq=rel-m01-07&orientation=portrait' },
    ],
  },
  '2': {
    id: '2',
    title: '我独自升级',
    author: '崔秀敏',
    genre: '奇幻 / 战斗',
    status: '连载中',
    rating: '9.7',
    views: '5,820万',
    favorites: '156万',
    description: '在一个连接着怪物与人类世界的"门"出现十年后，最弱的E级猎人成振宇在一次双重地下城事故中濒死之际，获得了神秘的"系统"。从此他开启了独自升级之路，一步步从最弱成长为最强，揭开隐藏在系统背后的惊天秘密。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20fantasy%20warrior%20with%20shadow%20army%2C%20glowing%20purple%20eyes%2C%20intense%20battle%20ready%20expression%2C%20dramatic%20lighting%20with%20purple%20and%20black%20tones%2C%20premium%20webtoon%20cover%20quality&width=600&height=800&seq=manhua-cover-02&orientation=portrait',
    tags: ['奇幻', '战斗', '系统', '升级', '暗影', '热血'],
    totalChapters: 179,
    chapters: genChapters(179, 'level'),
    relatedManhua: [
      { id: '1', title: '剑尊归来', author: '李贤宇', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20martial%20arts%20master%2C%20golden%20divine%20light%2C%20action%20webtoon%20cover&width=400&height=533&seq=rel-m02-01&orientation=portrait' },
      { id: '9', title: 'SSS级猎人', author: '郑宇硕', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20powerful%20hunter%2C%20dungeon%20background%2C%20orange%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m02-09&orientation=portrait' },
      { id: '4', title: '全知读者视角', author: '崔元英', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20reader%2C%20cosmic%20background%2C%20blue%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m02-04&orientation=portrait' },
    ],
  },
  '3': {
    id: '3',
    title: '女神降临',
    author: '朴世美',
    genre: '恋爱 / 校园',
    status: '已完结',
    rating: '9.5',
    views: '3,420万',
    favorites: '78万',
    description: '外貌平凡的女孩林周京通过化妆技术实现了惊人的变身，成为了校园里的"女神"。然而，她的素颜秘密却被学校里最受欢迎的两个男生意外发现了。一段关于美丽、自信与真爱的青春故事就此展开。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20beautiful%20female%20character%20with%20elegant%20makeup%2C%20soft%20romantic%20atmosphere%2C%20pastel%20pink%20and%20peach%20tones%2C%20school%20uniform%2C%20shojo%20style%20digital%20illustration%2C%20premium%20quality&width=600&height=800&seq=manhua-cover-03&orientation=portrait',
    tags: ['恋爱', '校园', '化妆', '青春', '治愈', '喜剧'],
    totalChapters: 256,
    chapters: genChapters(256, 'goddess'),
    relatedManhua: [
      { id: '6', title: '恶女重生', author: '郑雅拉', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20elegant%20female%20villainess%2C%20royal%20palace%2C%20burgundy%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m03-06&orientation=portrait' },
      { id: '8', title: '反派的美学', author: '金多彬', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20charismatic%20villain%2C%20dark%20elegant%20dress%2C%20gothic%20mansion%2C%20webtoon%20cover&width=400&height=533&seq=rel-m03-08&orientation=portrait' },
    ],
  },
  '4': {
    id: '4',
    title: '全知读者视角',
    author: '崔元英',
    genre: '奇幻 / 生存',
    status: '连载中',
    rating: '9.6',
    views: '4,180万',
    favorites: '92万',
    description: '金独子是一个普通上班族，唯一的爱好就是阅读一部连载了十年、总共三千多章的网络小说《在灭亡世界生存的三种方法》。就在小说完结的当天，他所处的世界突然变成了小说中的场景。凭借对剧情的全知全解，他成为了这个末世中唯一的"全知读者"。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20mysterious%20male%20reader%20surrounded%20by%20stories%2C%20apocalyptic%20world%20background%2C%20dramatic%20blue%20and%20gold%20lighting%2C%20omniscient%20theme%2C%20premium%20webtoon%20cover%20quality&width=600&height=800&seq=manhua-cover-04&orientation=portrait',
    tags: ['奇幻', '生存', '全知', '末世', '回归', '智斗'],
    totalChapters: 203,
    chapters: genChapters(203, 'reader'),
    relatedManhua: [
      { id: '2', title: '我独自升级', author: '崔秀敏', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dark%20fantasy%20warrior%2C%20purple%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m04-02&orientation=portrait' },
      { id: '10', title: '末日生存指南', author: '朴敏俊', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20survivor%20in%20apocalypse%2C%20green%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m04-10&orientation=portrait' },
    ],
  },
  '5': {
    id: '5',
    title: '世子消失了',
    author: '姜恩彩',
    genre: '古装 / 悬疑',
    status: '连载中',
    rating: '9.4',
    views: '1,890万',
    favorites: '42万',
    description: '朝鲜王朝的世子李韺在一夜之间神秘消失，整个王宫陷入恐慌。侍女韩秀妍在寻找世子的过程中，意外发现了隐藏在宫殿深处的惊天秘密。宫廷阴谋与世子失踪之间究竟有何关联？',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20historical%20Korean%20prince%20character%20in%20elegant%20hanbok%2C%20mysterious%20palace%20nighttime%20setting%2C%20warm%20lantern%20light%2C%20traditional%20Korean%20aesthetic%2C%20suspenseful%20atmosphere%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-05&orientation=portrait',
    tags: ['古装', '悬疑', '宫廷', '阴谋', '历史', '推理'],
    totalChapters: 98,
    chapters: genChapters(98, 'prince'),
    relatedManhua: [
      { id: '11', title: '龙王殿下请息怒', author: '李恩智', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dragon%20king%2C%20underwater%20palace%2C%20blue%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m05-11&orientation=portrait' },
      { id: '12', title: '囚笼中的公主', author: '韩素希', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20imprisoned%20princess%2C%20dark%20tower%2C%20silver%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m05-12&orientation=portrait' },
    ],
  },
  '6': {
    id: '6',
    title: '恶女重生',
    author: '郑雅拉',
    genre: '恋爱 / 重生',
    status: '连载中',
    rating: '9.3',
    views: '2,340万',
    favorites: '64万',
    description: '被皇帝赐死的恶女公爵艾莉西亚，临死前方知自己不过是皇权斗争的牺牲品。重生回到五年前，她决定不再做任何人的棋子。这一次，她要掌控自己的命运，做真正的"恶女"——所有伤害过她的人，一个都不会放过。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20elegant%20female%20villainess%20in%20vintage%20royal%20dress%2C%20dramatic%20burgundy%20and%20gold%20tones%2C%20imperial%20palace%20interior%2C%20powerful%20stance%2C%20revenge%20theme%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-06&orientation=portrait',
    tags: ['恋爱', '重生', '恶女', '复仇', '宫廷', '逆袭'],
    totalChapters: 145,
    chapters: genChapters(145, 'villainess'),
    relatedManhua: [
      { id: '3', title: '女神降临', author: '朴世美', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20beautiful%20girl%2C%20pink%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m06-03&orientation=portrait' },
      { id: '8', title: '反派的美学', author: '金多彬', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20villain%20character%2C%20dark%20red%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m06-08&orientation=portrait' },
    ],
  },
  '7': {
    id: '7',
    title: '成为伯爵家的废物',
    author: '赵云熙',
    genre: '奇幻 / 转生',
    status: '连载中',
    rating: '9.4',
    views: '2,100万',
    favorites: '48万',
    description: '现代大学生赵俊熙意外穿越到剑与魔法的奇幻世界，成为伯爵家众人口中的"废物"第三子。但没人知道，他体内寄宿着远古剑圣之魂。从魔法学院的吊车尾开始，他一步步证明自己的实力，踏上问鼎剑道巅峰之路。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20young%20nobleman%20character%20in%20fantasy%20academy%20uniform%2C%20holding%20sword%2C%20magical%20castle%20background%2C%20warm%20golden%20lighting%2C%20determined%20expression%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-07&orientation=portrait',
    tags: ['奇幻', '转生', '学院', '剑术', '逆袭', '成长'],
    totalChapters: 67,
    chapters: genChapters(67, 'count'),
    relatedManhua: [
      { id: '1', title: '剑尊归来', author: '李贤宇', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20martial%20arts%20master%2C%20golden%20light%2C%20webtoon%20cover&width=400&height=533&seq=rel-m07-01&orientation=portrait' },
      { id: '9', title: 'SSS级猎人', author: '郑宇硕', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20hunter%2C%20orange%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m07-09&orientation=portrait' },
    ],
  },
  '8': {
    id: '8',
    title: '反派的美学',
    author: '金多彬',
    genre: '恋爱 / 奇幻',
    status: '连载中',
    rating: '9.4',
    views: '1,560万',
    favorites: '38万',
    description: '前世是一名普通化妆师的她，穿越到了自己读过的小说中，成为了最终被主角团消灭的终极反派——魔女塞西莉亚。为了改变悲惨的命运，她决定用"美学"征服这个世界。谁说反派一定要丑恶？她要成为最美最强的反派！',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20charismatic%20female%20villain%20in%20dark%20elegant%20gothic%20dress%2C%20mysterious%20mansion%20interior%2C%20dramatic%20deep%20red%20and%20black%20tones%2C%20confident%20expression%2C%20elegant%20villainess%20theme%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-08&orientation=portrait',
    tags: ['恋爱', '奇幻', '反派', '穿越', '逆袭', '美学'],
    totalChapters: 89,
    chapters: genChapters(89, 'aesthetics'),
    relatedManhua: [
      { id: '6', title: '恶女重生', author: '郑雅拉', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20villainess%2C%20burgundy%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m08-06&orientation=portrait' },
      { id: '3', title: '女神降临', author: '朴世美', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20beautiful%20girl%2C%20pink%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m08-03&orientation=portrait' },
    ],
  },
  '9': {
    id: '9',
    title: 'SSS级猎人',
    author: '郑宇硕',
    genre: '动作 / 奇幻',
    status: '连载中',
    rating: '9.5',
    views: '2,890万',
    favorites: '72万',
    description: '在猎人等级制度森严的世界里，最低等的F级猎人金哲秀意外获得了一项能将任何技能瞬间提升至SSS级的神秘能力。从底层猎人到世界最强，他只用了一个月。各路人马纷纷开始关注这位横空出世的SSS级猎人。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fierce%20hunter%20warrior%20in%20combat%20stance%2C%20explosive%20energy%20aura%2C%20dungeon%20monsters%20background%2C%20dramatic%20orange%20and%20dark%20red%20tones%2C%20powerful%20action%20pose%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-09&orientation=portrait',
    tags: ['动作', '奇幻', '猎人', '升级', '战斗', '热血'],
    totalChapters: 134,
    chapters: genChapters(134, 'hunter'),
    relatedManhua: [
      { id: '2', title: '我独自升级', author: '崔秀敏', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20shadow%20warrior%2C%20purple%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m09-02&orientation=portrait' },
      { id: '1', title: '剑尊归来', author: '李贤宇', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20martial%20arts%20master%2C%20golden%20light%2C%20webtoon%20cover&width=400&height=533&seq=rel-m09-01&orientation=portrait' },
    ],
  },
  '10': {
    id: '10',
    title: '末日生存指南',
    author: '朴敏俊',
    genre: '生存 / 恐怖',
    status: '连载中',
    rating: '9.1',
    views: '890万',
    favorites: '25万',
    description: '一种神秘病毒席卷全球，感染者变成嗜血的怪物。普通大学生韩在元在这场灾难中觉醒了一项特殊能力——预知未来三秒。凭借这项能力，他在丧尸横行的末日世界中挣扎求生，并逐渐发现这场灾难背后隐藏的惊人真相。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20survivor%20character%20in%20post%20apocalyptic%20city%20ruin%2C%20zombie%20horde%20in%20distance%2C%20dark%20moody%20atmosphere%2C%20desaturated%20green%20and%20gray%20tones%2C%20eerie%20lighting%2C%20thriller%20survival%20theme%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-10&orientation=portrait',
    tags: ['生存', '恐怖', '丧尸', '末日', '觉醒', '悬疑'],
    totalChapters: 56,
    chapters: genChapters(56, 'survival'),
    relatedManhua: [
      { id: '4', title: '全知读者视角', author: '崔元英', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20reader%20in%20apocalypse%2C%20blue%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m10-04&orientation=portrait' },
      { id: '16', title: '深夜怪谈', author: '林智恩', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20ghostly%20figure%2C%20blue%20gray%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m10-16&orientation=portrait' },
    ],
  },
  '11': {
    id: '11',
    title: '龙王殿下请息怒',
    author: '李恩智',
    genre: '古装 / 恋爱',
    status: '连载中',
    rating: '9.3',
    views: '1,980万',
    favorites: '45万',
    description: '掌控四海的水龙王在一次大战中重伤坠入凡间，被一位人类女医师所救。为了报恩，龙王化身为将军府中的神秘客人，与救命恩人展开一段跨越种族与天命的爱情故事。然而天庭的追杀与凡间的纷争，让这段感情充满荆棘。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dragon%20king%20character%20with%20regal%20divine%20aura%2C%20underwater%20palace%20background%2C%20mystical%20blue%20and%20gold%20tones%2C%20fantasy%20romance%20theme%2C%20elegant%20traditional%20Asian%20aesthetic%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-11&orientation=portrait',
    tags: ['古装', '恋爱', '龙族', '奇幻', '神仙', '治愈'],
    totalChapters: 112,
    chapters: genChapters(112, 'dragon'),
    relatedManhua: [
      { id: '5', title: '世子消失了', author: '姜恩彩', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20historical%20prince%2C%20warm%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m11-05&orientation=portrait' },
      { id: '14', title: '天命之女', author: '张瑞妍', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20heroine%20with%20magic%2C%20purple%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m11-14&orientation=portrait' },
    ],
  },
  '12': {
    id: '12',
    title: '囚笼中的公主',
    author: '韩素希',
    genre: '古装 / 悬疑',
    status: '连载中',
    rating: '9.2',
    views: '1,450万',
    favorites: '32万',
    description: '公主李华珍在新婚之夜被囚禁于高塔之中，她的夫君——邻国太子——并非如表面那般温和善良。塔中岁月漫长而孤寂，公主在暗中收集线索，发现了一个足以颠覆两国关系的惊天阴谋。她必须逃出囚笼，揭露真相。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20imprisoned%20princess%20looking%20through%20high%20tower%20window%2C%20moonlight%20streaming%20in%2C%20dark%20stone%20room%2C%20melancholy%20blue%20and%20silver%20tones%2C%20gothic%20romance%20atmosphere%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-12&orientation=portrait',
    tags: ['古装', '悬疑', '宫斗', '逃亡', '阴谋', '成长'],
    totalChapters: 78,
    chapters: genChapters(78, 'prison'),
    relatedManhua: [
      { id: '5', title: '世子消失了', author: '姜恩彩', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20prince%2C%20warm%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m12-05&orientation=portrait' },
      { id: '6', title: '恶女重生', author: '郑雅拉', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20villainess%2C%20burgundy%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m12-06&orientation=portrait' },
    ],
  },
  '13': {
    id: '13',
    title: '星际流浪者',
    author: '崔成浩',
    genre: '科幻 / 冒险',
    status: '连载中',
    rating: '9.0',
    views: '680万',
    favorites: '18万',
    description: '地球资源枯竭后，人类开启了星际移民时代。飞船工程师姜河镇在一次航行事故中被抛入未知星系，独自一人漂流在茫茫宇宙中。他必须利用有限资源在陌生的星球间穿梭，寻找回家的路，同时揭开银河系深处被尘封的古老秘密。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20space%20adventurer%20in%20futuristic%20spacesuit%2C%20alien%20planet%20landscape%20with%20strange%20vegetation%20and%20distant%20moons%2C%20cosmic%20neon%20purple%20and%20blue%20colors%2C%20sci%20fi%20digital%20illustration%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-13&orientation=portrait',
    tags: ['科幻', '冒险', '宇宙', '生存', '探索', '机甲'],
    totalChapters: 45,
    chapters: genChapters(45, 'star'),
    relatedManhua: [
      { id: '4', title: '全知读者视角', author: '崔元英', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20reader%2C%20blue%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m13-04&orientation=portrait' },
      { id: '2', title: '我独自升级', author: '崔秀敏', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20shadow%20warrior%2C%20purple%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m13-02&orientation=portrait' },
    ],
  },
  '14': {
    id: '14',
    title: '天命之女',
    author: '张瑞妍',
    genre: '奇幻 / 恋爱',
    status: '已完结',
    rating: '9.2',
    views: '1,230万',
    favorites: '35万',
    description: '平凡少女白素琳在十八岁生日那天被天神告知，她是被选中的"天命之女"，肩负着阻止魔王复活的重任。在魔法学院中，她一边学习掌控自己的灵力，一边与命运邂逅的几位守护者发展出深厚的情感羁绊。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20destined%20heroine%20with%20glowing%20magical%20aura%2C%20enchanted%20forest%20with%20floating%20lights%20background%2C%20ethereal%20purple%20and%20white%20tones%2C%20mystical%20fantasy%20romance%20atmosphere%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-14&orientation=portrait',
    tags: ['奇幻', '恋爱', '魔法', '学院', '天命', '逆袭'],
    totalChapters: 201,
    chapters: genChapters(201, 'destiny'),
    relatedManhua: [
      { id: '7', title: '成为伯爵家的废物', author: '赵云熙', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20nobleman%20in%20academy%2C%20golden%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m14-07&orientation=portrait' },
      { id: '11', title: '龙王殿下请息怒', author: '李恩智', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20dragon%20king%2C%20blue%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m14-11&orientation=portrait' },
    ],
  },
  '15': {
    id: '15',
    title: '社长的小娇妻',
    author: '崔美兰',
    genre: '恋爱 / 职场',
    status: '连载中',
    rating: '9.1',
    views: '980万',
    favorites: '22万',
    description: '刚毕业的实习生朴素英进入全国最大的企业集团工作，意外发现外表冷酷的社长竟然是三年前与自己有过一面之缘的咖啡店老板。从职场新人到社长夫人，她的逆袭之路充满了甜蜜与挑战。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20office%20romance%20couple%20in%20modern%20corporate%20setting%2C%20elegant%20professional%20attire%2C%20city%20skyline%20through%20glass%20window%2C%20warm%20golden%20hour%20lighting%2C%20sweet%20romantic%20atmosphere%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-15&orientation=portrait',
    tags: ['恋爱', '职场', '社长', '逆袭', '喜剧', '治愈'],
    totalChapters: 167,
    chapters: genChapters(167, 'boss'),
    relatedManhua: [
      { id: '3', title: '女神降临', author: '朴世美', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20beautiful%20girl%2C%20pink%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m15-03&orientation=portrait' },
      { id: '6', title: '恶女重生', author: '郑雅拉', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20villainess%2C%20burgundy%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m15-06&orientation=portrait' },
    ],
  },
  '16': {
    id: '16',
    title: '深夜怪谈',
    author: '林智恩',
    genre: '恐怖 / 悬疑',
    status: '连载中',
    rating: '8.9',
    views: '560万',
    favorites: '15万',
    description: '转学生金敏珠来到一所被传言笼罩的高中，校园里流传着各种令人毛骨悚然的怪谈——午夜音乐教室的钢琴声、三楼女厕所的哭声、图书馆深处的禁书。当她的同学们开始一个个神秘消失，她意识到这些怪谈可能是真的。',
    coverImageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20ghostly%20figure%20in%20dark%20school%20hallway%2C%20eerie%20supernatural%20atmosphere%2C%20creepy%20abandoned%20classroom%2C%20moody%20blue%20and%20gray%20color%20tones%2C%20horror%20suspense%20theme%2C%20premium%20webtoon%20cover&width=600&height=800&seq=manhua-cover-16&orientation=portrait',
    tags: ['恐怖', '悬疑', '校园', '怪谈', '推理', '灵异'],
    totalChapters: 34,
    chapters: genChapters(34, 'ghost'),
    relatedManhua: [
      { id: '10', title: '末日生存指南', author: '朴敏俊', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20survivor%2C%20green%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m16-10&orientation=portrait' },
      { id: '12', title: '囚笼中的公主', author: '韩素希', imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20princess%2C%20silver%20tones%2C%20webtoon%20cover&width=400&height=533&seq=rel-m16-12&orientation=portrait' },
    ],
  },
};

export const manhuaFAQ = [
  {
    question: '虚空韩漫网的漫画都是免费的吗？',
    answer: '是的，虚空韩漫网上所有韩国漫画均为完全免费阅读。我们致力于为华语读者提供无障碍的韩漫阅读体验，无需付费，无需注册，随时随地畅享无删减韩漫内容。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是韩漫特有的阅读方式，您只需向下滑动页面即可连续阅读，无需翻页。这种设计适合手机阅读，体验流畅自然。在虚空韩漫网，所有漫画均支持下拉式阅读。',
  },
  {
    question: '虚空韩漫网的漫画更新频率如何？',
    answer: '虚空韩漫网与韩国原作保持同步更新，大部分热门作品每日更新。我们的翻译团队全天候工作，确保第一时间为读者奉上最新汉化章节。',
  },
  {
    question: '漫画内容是否经过删减？',
    answer: '虚空韩漫网坚持提供无删减版本的韩国漫画。我们尊重原作的完整性和艺术表达，所有内容均保持与韩文原版一致，让读者体验原汁原味的韩漫魅力。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航按题材浏览漫画，也可以使用搜索功能直接查找作品名称。热门作品排行榜和专题推荐也能帮助您发现优质的韩漫作品。',
  },
];